<template>
	<FloatingAccordionMenu v-if="isAccordionMenuOpen" @closeMenu="onMenuClose" class="accordion-menu">
		<component
			v-on="$listeners"
			v-bind="accordionMenuItem.props"
			:class="accordionMenuItem.class"
			:is="accordionMenuItem.component"
			@action-selected="onMenuClose"
		/>
	</FloatingAccordionMenu>
</template>

<script>
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { setEditorAccordionMenuItems, setIsEditorAccordionMenuOpen } from '@/store/modules/blockEditor/actions';
import { editorAccordionMenuItems, isAccordionMenuOpen } from '@/store/modules/blockEditor/getters';
import { setIsChangingAction } from '@/store/modules/blockEditor/actions';

import FloatingAccordionMenu from '../FloatingAccordionMenu';

export default {
	name: 'BlockEditorAccordionMenu',
	components: {
		FloatingAccordionMenu,
	},
	computed: {
		...mapGettersShorthand({ editorAccordionMenuItems, isAccordionMenuOpen }),
		accordionMenuItem() {
			return this.editorAccordionMenuItems;
		},
	},
	methods: {
		...mapActionsShorthand({ setEditorAccordionMenuItems, setIsEditorAccordionMenuOpen, setIsChangingAction }),
		onMenuClose() {
			this.setIsEditorAccordionMenuOpen(false);
			this.setIsChangingAction(false);
		},
	},
};
</script>

<style scoped lang="scss">
$z-index-floating-accordion: $z-index-content-switcher + 1;

.accordion-menu {
	z-index: $z-index-floating-accordion;
}
</style>
